module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', [_vm._v("About the Author")]), _vm._v(" "), _c('p', [_vm._v("Even at the age of 79, Terens Daffyd Llaw is an avid walker, a pursuit that has taken up much of his time, since he retired 20 years ago. With Offah’s Dyke both ways, the Pembrokeshire Coast Path and a host of walks in Australia and New Zealand behind him, he was attracted to the walk George Borrow took through Wales in 1854. Reading Borrow’s account of his walk in his classic book Wild Wales, immediately prompted an interest in comparing the world of Borrow with the changes that have occurred over 150 years and made the world today a very different place to what it was in his day.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ad60488","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0